<template>
  <Teleport
    to="#Teleport-footer-modals"
  >
    <transition :name="animateClass">
      <div
        v-if="modelValue"
        class="Modal-mask"
        @click.prevent="handleOutsideClick()"
      >
        <div
          :class="['Modal-wrapper', modalClass, extraClasses]"
          @click.stop
        >
          <div class="Modal-container">
            <button
              v-if="!preventClose"
              class="Modal-closeIcon"
              @click="closeModal"
            >
              <span class="far fa-times" />
            </button>
            <div class="Modal-header">
              <slot name="modal-header" />
            </div>
            <div class="Modal-body">
              <slot name="modal-body" />
            </div>
            <div class="Modal-footer">
              <div class="ButtonGroup">
                <slot name="modal-footer" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </Teleport>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    extraClasses: {
      type: String,
      default: '',
    },
    modalStyle: {
      type: String,
      default: '',
    },
    preventClose: {
      type: Boolean,
      default: false,
    },
    preventOutsideClick: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue', 'base-modal:opened', 'base-modal:closed'],
  computed: {
    animateClass() {
      return this.modalStyle === 'bottom-sheet' ? 'BottomSheet' : 'Modal';
    },
    modalClass() {
      return this.modalStyle === 'bottom-sheet' ? 'Modal--bottomSheet' : 'Modal--center';
    },
  },
  watch: {
    modelValue: {
      handler(val) {
        if (val) {
          this.$emit('base-modal:opened');
        } else {
          this.$emit('base-modal:closed');
        }
      },
    },
  },
  mounted() {
    if (!this.preventClose) {
      document.addEventListener('keyup', (e) => {
        if (this.modelValue && e.keyCode === 27) {
          this.closeModal();
        }
      });
    }
  },
  methods: {
    handleOutsideClick() {
      if (!this.preventClose && !this.preventOutsideClick) {
        this.$emit('update:modelValue', false);
      }
    },
    closeModal() {
      if (!this.preventClose) {
        this.$emit('update:modelValue', false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>

  @import '../../../scss/abstracts/abstracts.scss';
  //New  Vue Modal ==============================
  .ModalCont{
    position: relative;
  }
  .Modal-mask {
    position: fixed;
    z-index: 9999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
  }

  .Modal-wrapper {
    display: block;
    position: fixed;
    width: 100%;
    top: 50%;
    left: 50%;
    text-align: left;
    transform: translate(-50%, -50%);
    /*overflow-y: auto;*/
    @include respond-to(sm) {
      width: auto;
    }

  }

  .Modal-container {
    max-width: 600px;
    position: relative;
    margin: 0px auto;
    background-color: #fff;
    border-radius: radius();
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    padding: spacing(lg);
    overflow: auto;
    overflow-y: auto !important;
    max-height: calc(100vh - 30px);
    max-width: calc(100vw - 30px);
    @include respond-to(sm, max-width) {
      /*position: fixed;*/
      overflow-y: scroll;
      max-height: 100vh;
    }
    @include respond-to(md) {
      width: 500px;
    }
  }

  .Modal--large {
    @include respond-to(sm, max-width) {
      width: 100%;
      top: 0;
      left: 0;
      transform: none;
      .Modal-closeIcon{
        position: fixed;
      }
    }
    .Modal-container {
      @include respond-to(sm, max-width) {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        height: 100vh;
        overflow-y: scroll;
        width: 100%;
        max-width: 100%;
      }
      @include respond-to(sm) {
        max-width: 1000px;
        width: 100%;
        min-width: 700px;
      }
    }
  }

  .Modal--noSpacing {
    .Modal-body {
      margin: 0;
    }

    .Modal-container {
      padding: 0;
    }
  }

  .Modal-header h2 {
    margin-top: 0;
  }

  .Modal-body {
    margin: 20px 0;
  }

  .Modal-closeIcon {
    position: fixed;
    top: 0;
    right: 16px;
    height: 40px;
    cursor: pointer;
    font-size: rem(18px);
    width: 40px;
    line-height: 40px;
    text-align: center;
    z-index: 2;
    @include respond-to(xs) {
      position: absolute;
      right: 0;
    }
  }

  :deep(.Modal-footer) {
    width: 100%;
    display: flex;
    text-align: right;

    .ButtonGroup {
      display: flex;
      width: 100%;
      justify-content: space-between;
    }

    .ButtonGroup-item {
      @include respond-to(sm, max-width) {
        width: 100%;
        margin-bottom: spacing(sm);
        &:first-child {
          order: 2;
        }
      }
    }

    .Button {
      min-width: 100px;
      width: 100%;
      @include respond-to(sm) {
        min-width: 160px;
      }

      &:last-child {
        margin-left: auto;
      }
    }
  }

  /*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */

  // Modal Animation
  .Modal-enter {
    opacity: 0;
  }

  .Modal-leave-active {
    opacity: 0;
  }

  .Modal-enter .Modal-container,
  .Modal-leave-active .Modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  .Modal-leave-active {
    opacity: 0;
  }

  .Modal-enter .Modal-container,
  .Modal-leave-active .Modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  // BottomSheet Animation
  .BottomSheet-enter {
    opacity: 0;
  }

  .BottomSheet-leave-active {
    opacity: 0;
  }

  .BottomSheet-enter .Modal-container,
  .BottomSheet-leave-active .Modal-container {
    transform: translateY(100%);
  }

  .BottomSheet-leave-active {
    opacity: 0;
  }

  .BottomSheet-enter .BottomSheet-container,
  .BottomSheet-leave-active .BottomSheet-container {
    transform: translateY(100%);
  }

  .Modal--bottomSheet {
    bottom: 0;
    position: fixed;
    right: spacing(sm);
    left: spacing(sm);
    top: auto;
    transform: none;

    .Modal-container {
      max-width: 768px;
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
    }
  }

  .Modal-wrapper.FullWidth {
    width: 100%;
    max-width: none;

    .Modal-container {
      max-width: none;
      width: 100%;
    }
  }

  .Modal-wrapper.Success {
    .Modal-header {
      > * {
        color: color('green');
      }
    }
  }

  .Modal-wrapper.Error {
    .Modal-header {
      > * {
        color: color('red');
      }
    }
  }

  .Modal-wrapper.Center {
    text-align: center;
  }

</style>
